import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-logo">HandyFixWise</div>
        <div className="footer-info">
          <p>© {new Date().getFullYear()} HandyFixWise. All Rights Reserved.</p>
        </div>
        <div className="footer-social">
          <a href="https://www.yelp.com/biz/handyfixwise-los-angeles" target="_blank" rel="noopener noreferrer">Yelp</a>
          <a href="https://www.thumbtack.com/ca/los-angeles/handyman/mike-handyfixwise/service/471065382966566936" target="_blank" rel="noopener noreferrer">Thumbtack</a>
        </div>
      </div>
      <div className="footer-serving-area">
        Serving: Northridge • Reseda • Granada Hills • Porter Ranch • Chatsworth • Winnetka • Canoga Park • Van Nuys
      </div>
    </footer>
  );
};

export default Footer;
